import { Ability, AbilityClass, createAliasResolver } from '@casl/ability';

export const resolveAction = createAliasResolver({
    c: ['create'],
    r: ['read'],
    u: ['update'],
    d: ['delete'],
    x: ['execute']
});

type appSubjects = 'MWS';
export type appActions = 'c' | 'r' | 'u' | 'd' | 'x' | 'create' | 'read' | 'update' | 'delete' | 'execute';

export type AppAbilities = [appActions, appSubjects];

export type AppAbility = Ability<AppAbilities>;
export const AppAbility = Ability as AbilityClass<AppAbility>;
